import { flowRight as compose } from 'lodash'

import { withAuthLayout } from './withAuthLayout'

export const withAuthPage = () => {
  return function (Component) {
    return compose(withAuthLayout)(Component)
  }
}
